
import { defineComponent, PropType } from 'vue'

// @components
import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    components: {
        Cheap,
    },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    setup() {
        const getCheckOrTimesIcon = (is_check: boolean) => {
            return `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`
        }

        return { getCheckOrTimesIcon }
    },
})
